var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stationId ? _vm.station : _vm.newStation)?_c('StationForm',{attrs:{"station":_vm.stationId ? _vm.station : _vm.newStation,"is-edit":!!_vm.stationId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }